import { render, staticRenderFns } from "./DetailPageHeroMenus.vue?vue&type=template&id=1794d533"
import script from "./DetailPageHeroMenus.vue?vue&type=script&lang=js"
export * from "./DetailPageHeroMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,SanityFile: require('/vercel/path0/node_modules/@nuxtjs/sanity/dist/components/sanity-file.js').default})
